import Constants from '../utils/consts';
import Cookies from 'universal-cookie';
import Utils from '../utils/utils';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function getLezioni(uname, token) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'getLezioni.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(Utils.unescapeString(body.toString()));
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'hiddenClasses': 1,
        'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
